export default __webpack_public_path__ + "stack-exchange-logo.png";